import { Suspense } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { ErrorBoundary } from 'react-error-boundary'
import { ConfigProvider, zhCN, Loading } from 'mk-pc'

const ErrorFallback = () => {
  return (
    <div className="f">
      <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
      <button>refresh</button>
    </div>
  )
}

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#a51e24',
          colorInfo: '#a51e24',
          colorTextBase: '#000000e6',
          controlHeight: 34,
          controlHeightLG: 44,
          controlHeightSM: 24,
          borderRadius: 4
        },
        components: {
          Input: {
            activeShadow: '0 0 0 1px rgba(165, 30, 36, 0.5)'
          },
          Menu: {
            itemHoverBg: 'rgba(165, 31, 36, 0.08)',
            itemHoverColor: 'rgb(165, 30, 36)',
            subMenuItemBg: 'rgb(255, 255, 255)',
            itemSelectedBg: 'rgba(165, 30, 36, 0.08)',
            itemActiveBg: 'rgba(165, 30, 36, 0.08)'
          }
        }
      }}
    >
      <Suspense fallback={<Loading />}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <HelmetProvider>
            <Helmet>
              <title>KIEFER</title>
            </Helmet>
            {children}
          </HelmetProvider>
        </ErrorBoundary>
      </Suspense>
    </ConfigProvider>
  )
}
